'use client'
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/media/ContentfulImage.tsx
import { useMemo } from "react";
import { ImageWithPlaceholder } from "@wbk/ui";
import { jsx } from "react/jsx-runtime";
var ContentfulImage = (_a) => {
  var _b = _a, {
    format = "webp",
    fit,
    width,
    height,
    src,
    placeholder
  } = _b, props = __objRest(_b, [
    "format",
    "fit",
    "width",
    "height",
    "src",
    "placeholder"
  ]);
  const query = useMemo(() => {
    if (!src)
      return "";
    const imgSrcParams = new URL(src).searchParams;
    const searchParams = new URLSearchParams(imgSrcParams);
    if (src.endsWith(".svg")) {
      return "";
    }
    if (format)
      searchParams.set("fm", format);
    if (fit)
      searchParams.set("fit", fit);
    if (width && typeof width === "number")
      searchParams.set("w", width.toString());
    if (height && typeof height === "number")
      searchParams.set("h", height.toString());
    return "?" + searchParams.toString();
  }, [src, format, width, fit, height]);
  const newSrc = useMemo(() => {
    if (!src)
      return "";
    const srcWithoutParams = src.replace(/\?.*/, "");
    return `${srcWithoutParams}${query}`;
  }, [src, query]);
  const Comp = placeholder ? ImageWithPlaceholder : "img";
  return /* @__PURE__ */ jsx(Comp, __spreadValues({ src: newSrc, width, height }, props));
};
var ContentfulImage_default = ContentfulImage;

// src/components/media/ContentfulMedia.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var ContentfulMedia = (_a) => {
  var _b = _a, { media, placeholder, ref } = _b, props = __objRest(_b, ["media", "placeholder", "ref"]);
  var _a2;
  const video = (_a2 = media.contentType) == null ? void 0 : _a2.includes("video");
  if (video) {
    return (
      // eslint-disable-next-line jsx-a11y/media-has-caption
      /* @__PURE__ */ jsx2(
        "video",
        __spreadProps(__spreadValues({
          poster: props.poster,
          playsInline: true,
          disablePictureInPicture: true
        }, props), {
          className: `cursor-pointer ${props.className || ""}`,
          ref,
          children: /* @__PURE__ */ jsx2("source", { src: media.url, type: media.contentType })
        })
      )
    );
  }
  if (media.url.includes("youtube.com")) {
    return /* @__PURE__ */ jsx2(
      "iframe",
      {
        title: media.title,
        width: "100%",
        height: "100%",
        src: media.url,
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        className: props.className
      }
    );
  }
  return /* @__PURE__ */ jsx2(
    ContentfulImage_default,
    __spreadValues({
      src: media.url,
      alt: media.title,
      width: media.width,
      height: media.height,
      placeholder
    }, props)
  );
};
var ContentfulMedia_default = ContentfulMedia;

export {
  ContentfulMedia_default
};
//# sourceMappingURL=chunk-IOBZ5NBW.mjs.map